import { MsxProduct } from '@clients/MsxService';
import { ApplicationState } from './model/ApplicationState';
import { ScopeDefinition } from './model/ScopeDefinition';
import { Attribute } from '@clients/DiscoveryPagesService';

export const CONTENTFUL_FIELD_SCOPE_DEFINITION = 'scopeDefinition';
export const SUPPORT_CHANNEL_NAME = '#team-site-search';
export const SUPPORT_CHANNEL_URL = 'https://vistaprint.slack.com/archives/C07C7FLQ10B';
export const MOQ_FACET_KEY = 'moq';
export const MOQ_FACET_VALUE = 1;
export const EMPTY_SCOPE_DEFINITION: ScopeDefinition = {
  default: { categories: [], products: [], attributes: [], facets: [], useOldScope: true, useCsvProductInput: false },
};
export const EMPTY_APPLICATION_STATE: ApplicationState = {
  categories: [],
  products: [],
  attributes: [],
  tags: [],
  moq: false,
  useOldScope: true,
  useCsvProductInput: false,
};
export const EMPTY_PRODUCT: MsxProduct = { mpvId: '', productKey: '' };
export const EMPTY_ATTRIBUTE: Attribute = { name: '', values: [] };
